import React from 'react';

const ServicesGrid = () => {
  const logo = (
    <img
      src="/assets/images/logo12.png"
      alt="Testa Care logo"
      className="h-28 w-80 mx-auto mb-4 object-contain scale-150"
      loading="lazy"
    />
  );

  const services = [
    {
      title: 'Our Homes',
      image: '/assets/images/Our Homes.jpg',
      link: '/our-homes'
    },
    {
      title: 'Therapy Services',
      image: '/assets/images/therapy-services-hero.jpg',
      link: '/therapy-services'
    }
  ];

  return (
    <div id="services" className="bg-white w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
      <div className="flex lg:grid lg:grid-cols-2 gap-0 bg-white overflow-x-auto lg:overflow-visible w-full snap-x snap-mandatory">
        {services.map((service, index) => (
          <a
            key={index}
            href={service.link}
            className="cta group relative block h-96 w-full min-w-full lg:min-w-0 flex-none overflow-hidden snap-start"
          >
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
              style={{ backgroundImage: `url('${service.image}')` }}
            ></div>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-30 transition-all duration-300"></div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-white p-8">
              {logo}
              <h3 className="text-3xl font-light text-center">
                {service.title}
              </h3>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ServicesGrid;
